import type { RouteRecordRaw } from 'vue-router';

export const DESIGN_SYSTEM_BASE = '/design-system';

/**
 * One route for the whole gallery: GalleryApp resolves the page from the path itself, so the
 * portal routers only register this record and the gallery's pages stay in their own lazy chunk.
 * `hideNavBar` renders it without the portal frame; the gallery brings its own sidebar.
 */
export const designSystemRoute: RouteRecordRaw = {
    path: `${DESIGN_SYSTEM_BASE}/:pathMatch(.*)*`,
    name: 'design-system',
    component: () => import('./GalleryApp.vue'),
    meta: { requiresAuth: true, hideNavBar: true },
};

/**
 * What the portal routers spread in: the gallery on dev and branch builds only, the same gate as
 * the dev menu (`isDevToolsEnabled`). Staging/prod images are built without VITE_DEV_TOOLS, so
 * there the route and the whole gallery chunk are compiled out, not merely hidden. The condition
 * is spelled out rather than calling `isDevToolsEnabled()`: Rollup only drops the dead
 * `import('./GalleryApp.vue')` when it can fold the literals Vite inlines here.
 */
export const portalDesignSystemRoutes: RouteRecordRaw[] =
    import.meta.env.DEV || import.meta.env.VITE_DEV_TOOLS === 'true' ? [designSystemRoute] : [];
